export default __webpack_public_path__ + "static/media/link.8a8087f4.svg";